import React from 'react';
import { Link, useParams } from 'react-router';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { observer } from 'mobx-react-lite';

import { Header } from './project.page';
import { Location } from '../../app/entities/location';
import { FolderView } from '../../features/assets/components/folder-view';
import { Asset } from '../../app/entities/asset';
import { AssetViewerScreen } from '../../features/assets/screens/asset-viewer.screen';
import { AssetNameEditor } from '../../features/assets/components/asset-name-editor';
import { catchError } from '../../core/catch-error';

import styles from './project-location-asset.route.module.scss';
export const ProjectLocationAssetRoute: React.FC = observer(() => {
  const { locationId, assetId } = useParams() as { locationId: string; assetId: string };

  const location = Location.getOne(locationId)!;
  const asset = Asset.getOne(assetId)!;

  const handleRename = async (name: string) => {
    try {
      await asset.update({ name });
    } catch (e) {
      catchError(e);
    }
  };

  return (
    <>
      <Header>
        <div className={styles['crumb']}>
          <Link className={styles['parent']} to="../">
            Locations
          </Link>
          <ChevronRightIcon />
          <Link className={styles['parent']} to="../">
            {location.name}
          </Link>
          <ChevronRightIcon />
          <AssetNameEditor name={asset.name} onRename={handleRename} />
        </div>
      </Header>

      <div className={styles['container']}>
        {asset.type === 'folder' ? (
          <FolderView folderId={assetId} />
        ) : (
          <AssetViewerScreen asset={asset} />
        )}
      </div>
    </>
  );
});
